import { host_haiji_url } from '@/api/host'
var clientUserApi = {
  /**
   * 用户列表
   */
  getUserList: `${host_haiji_url}/v2/admin/users`, //获取用户列表  http://projectdoc.epetbar.com/index.php?s=/177&page_id=3960
  getScoreLog: `${host_haiji_url}/v1/admin/users/`, //查询用户积分变动列表  http://projectdoc.epetbar.com/index.php?s=/177&page_id=3961
  editScore: `${host_haiji_url}/v1/admin/users/score/`, //客服修改用户积分  http://projectdoc.epetbar.com/index.php?s=/177&page_id=3962
  disableStatus: `${host_haiji_url}/v1/admin/users/disable/`, //禁用C端用户  http://projectdoc.epetbar.com/index.php?s=/177&page_id=3966
  enableStatus: `${host_haiji_url}/v1/admin/users/enable/`, //启用C端用户  http://projectdoc.epetbar.com/index.php?s=/177&page_id=4070

  /**
   * 用户详情
   */
  getUserDetail: `${host_haiji_url}/v1/admin/users/`, //获取用户详情  http://projectdoc.epetbar.com/index.php?s=/177&page_id=3967
  getPetList: `${host_haiji_url}/v1/admin/users/`, //获取用户宠物列表  http://projectdoc.epetbar.com/index.php?s=/177&page_id=3969
  getSearchLog: `${host_haiji_url}/v1/admin/sticker_query_records/users/`, //获取用户防伪码查询记录列表  http://projectdoc.epetbar.com/index.php?s=/177&page_id=3970
  //导出用户列表
  getExportUserListUrl: `${host_haiji_url}/v1/admin/users/export`,//获取用户列表导出 http://projectdoc.epetbar.com/web/#/177?page_id=4614
}

export { clientUserApi }
